import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Spinner,
  Row,
  Col,
  Container,
  Input,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  Badge,
} from "reactstrap";
import axios from "axios";
import Header from "components/Headers/Header";
import EditarHistoricoSicom from "./EditarHistoricoSicom";

const ConsultaHistoricoSicom = () => {
  /* =========================
     ESTADOS
  ========================== */
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [pagina, setPagina] = useState(1);
  const registrosPorPagina = 10;

  const [placa, setPlaca] = useState("");
  const [vin, setVin] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState("GENERAL"); // GENERAL | PLACA | VIN

  const [modalOpen, setModalOpen] = useState(false);
  const [registroSeleccionado, setRegistroSeleccionado] = useState(null);
  const [modalEditar, setModalEditar] = useState(false);

  /* =========================
     UTILIDADES
  ========================== */
  const formatearFecha = (fecha) => {
    if (!fecha) return "-";
    return new Date(fecha).toLocaleDateString("es-CO");
  };

  const toggleModal = () => setModalOpen(!modalOpen);

  /* =========================
     CONSUMO API
  ========================== */
  const obtenerDatos = async () => {
    setLoading(true);
    try {
      let url = "";

      if (tipoBusqueda === "PLACA") {
        url = `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerHistoricoSicomPorPlaca/${placa}`;
      } else if (tipoBusqueda === "VIN") {
        url = `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerHistoricoSicomPorVin/${vin}`;
      } else {
        url = `https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerHistoricoSicom/${pagina}/${registrosPorPagina}`;
      }

      const response = await axios.get(url);
      setData(response.data || []);
    } catch (error) {
      console.error("Error al consumir la API", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    obtenerDatos();
  }, [pagina, tipoBusqueda]);

  /* =========================
     ACCIONES
  ========================== */
  const buscarPorPlaca = () => {
    setTipoBusqueda("PLACA");
    setPagina(1);
  };

  const buscarPorVin = () => {
    setTipoBusqueda("VIN");
    setPagina(1);
  };

  const limpiarBusqueda = () => {
    setPlaca("");
    setVin("");
    setTipoBusqueda("GENERAL");
    setPagina(1);
  };

  /* =========================
     DETALLE CONSOLIDADO
  ========================== */
  const verDetalle = (item) => {
    setRegistroSeleccionado({
      ...item,
      cilindros: item.cilindros || [],
      reguladores: item.reguladores || [],
    });
    setModalOpen(true);
  };

  const editarRegistro = (item) => {
    setRegistroSeleccionado({
      ...item,
      cilindros: item.cilindros || [],
      reguladores: item.reguladores || [],
    });
    setModalEditar(true);
  };

  return (
    <>
      <Header />

      <EditarHistoricoSicom
        open={modalEditar}
        toggle={() => setModalEditar(!modalEditar)}
        registro={registroSeleccionado}
        onSuccess={obtenerDatos}
      />

      <Container className="mt--7" fluid>
        <h4 className="mb-4">Consulta Histórico SICOM</h4>

        {/* ================= BUSCADORES ================= */}
        <Form className="mb-4">
          <Row>
            <Col md="3">
              <FormGroup>
                <Input
                  placeholder="Placa"
                  value={placa}
                  onChange={(e) => setPlaca(e.target.value.toUpperCase())}
                  disabled={tipoBusqueda === "VIN"}
                />
              </FormGroup>
            </Col>

            <Col md="3">
              <FormGroup>
                <Input
                  placeholder="VIN"
                  value={vin}
                  onChange={(e) => setVin(e.target.value.toUpperCase())}
                  disabled={tipoBusqueda === "PLACA"}
                />
              </FormGroup>
            </Col>

            <Col md="2">
              <Button
                color="primary"
                block
                disabled={!placa}
                onClick={buscarPorPlaca}
              >
                🔎 Placa
              </Button>
            </Col>

            <Col md="2">
              <Button color="info" block disabled={!vin} onClick={buscarPorVin}>
                🔎 VIN
              </Button>
            </Col>

            <Col md="2">
              <Button color="secondary" block onClick={limpiarBusqueda}>
                Limpiar
              </Button>
            </Col>
          </Row>
        </Form>

        {/* ================= LOADING ================= */}
        {loading ? (
          <div className="text-center my-5">
            <Spinner color="primary" />
          </div>
        ) : (
          <>
            {/* ================= TABLA ================= */}
            <Table bordered responsive hover size="sm" className="table-flush">
              <thead className="thead-light">
                <tr>
                  <th>ID</th>
                  <th>Placa</th>
                  <th>VIN</th>
                  <th>Chip ROM</th>
                  <th>F. Conversión</th>
                  <th>F. Últ. Revisión</th>
                  <th>F. Próx PH</th>
                  <th>F. Últ. Prueba</th>
                  <th>F. Instalación Cilindro</th>
                  <th>NIT Certificador</th>
                  <th>Certificador</th>
                  <th>Ciudad</th>

                  <th>F. Fabricación</th>
                  <th>Tipo Equipo</th>
                  <th>Marca Cilindro</th>
                  <th>Serial Cilindro</th>
                  <th>Capacidad</th>

                  <th>Marca Regulador</th>
                  <th>Serial Regulador</th>
                  <th className="text-center">Cilindros</th>
                  <th className="text-center">Reguladores</th>
                  <th className="text-center">Detalle</th>
                </tr>
              </thead>

              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="22" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  data.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.placa || "-"}</td>
                      <td>{item.vin || "-"}</td>
                      <td>{item.chipIdRom}</td>
                      <td>{formatearFecha(item.fechaConversion)}</td>
                      <td>{formatearFecha(item.fechaUltimaRevision)}</td>
                      <td>{formatearFecha(item.fechaProximaPh)}</td>
                      <td>{formatearFecha(item.fechaUltimaPrueba)}</td>
                      <td>{formatearFecha(item.fechaInstalacionCilindro)}</td>
                      <td>{item.nitCertificador || "-"}</td>
                      <td>{item.certificador || "-"}</td>
                      <td>{item.ciudad}</td>

                      <td>{formatearFecha(item.fechaFabricacion)}</td>
                      <td>{item.tipoEquipo || "-"}</td>
                      <td>{item.marcaCilindro || "-"}</td>
                      <td>{item.serialCilindro || "-"}</td>
                      <td>{item.capacidad || "-"}</td>

                      <td>{item.marcaRegulador || "-"}</td>
                      <td>{item.serialRegulador || "-"}</td>
                      <td className="text-center">
                        {item.cilindros?.length || 0}
                      </td>
                      <td className="text-center">
                        {item.reguladores?.length || 0}
                      </td>
                      <td className="text-center">
                        <Button
                          color="info"
                          size="sm"
                          onClick={() => verDetalle(item)}
                        >
                          Ver
                        </Button>
                      </td>

                      <td>
                        <Button
                          color="warning"
                          size="sm"
                          className="ms-1"
                          onClick={() => editarRegistro(item)}
                        >
                          Editar
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            {tipoBusqueda === "GENERAL" && (
              <Row className="mt-3">
                <Col className="d-flex justify-content-between align-items-center">
                  <Button
                    color="secondary"
                    disabled={pagina === 1}
                    onClick={() => setPagina(pagina - 1)}
                  >
                    Anterior
                  </Button>

                  <span>Página {pagina}</span>

                  <Button
                    color="primary"
                    disabled={data.length < registrosPorPagina}
                    onClick={() => setPagina(pagina + 1)}
                  >
                    Siguiente
                  </Button>
                </Col>
              </Row>
            )}
          </>
        )}

        {/* ================= MODAL DETALLE ================= */}
        <Modal isOpen={modalOpen} toggle={toggleModal} size="xl" centered>
          <ModalHeader toggle={toggleModal} className="bg-light">
            <div className="d-flex align-items-center gap-2">
              <span className="fw-bold">Detalle Técnico</span>
              <Badge color="primary">
                {registroSeleccionado?.placa || registroSeleccionado?.vin}
              </Badge>
            </div>
          </ModalHeader>

          <ModalBody style={{ maxHeight: "75vh", overflowY: "auto" }}>
            {registroSeleccionado && (
              <>
                {/* ================= CILINDROS ================= */}
                <Card className="mb-4 shadow-sm">
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">🛢️ Cilindros</h5>
                      <Badge color="info" pill>
                        {registroSeleccionado.cilindros?.length || 0}
                      </Badge>
                    </div>

                    <Row>
                      {(registroSeleccionado.cilindros || []).map((c, i) => (
                        <Col md="4" key={i} className="mb-3">
                          <Card className="h-100 border-0 shadow-sm">
                            <CardBody>
                              <h6 className="fw-bold mb-2 text-primary">
                                {c.marcaCilindro || "Sin marca"}
                              </h6>

                              <div className="small text-muted">
                                <div>
                                  <strong>Serial:</strong>{" "}
                                  {c.serialCilindro || "-"}
                                </div>
                                <div>
                                  <strong>Capacidad:</strong>{" "}
                                  {c.capacidad || "-"}
                                </div>
                                <div>
                                  <strong>Fabricación:</strong>{" "}
                                  {formatearFecha(c.fechaFabricacion)}
                                </div>
                                <div>
                                  <strong>Próx. PH:</strong>{" "}
                                  {formatearFecha(c.fechaProximaPh)}
                                </div>
                                <div>
                                  <strong>Ult. Prueba:</strong>{" "}
                                  {formatearFecha(c.fechaUltimaPrueba)}
                                </div>
                                <div>
                                  <strong>
                                    Fecha instalacion del cilindro:
                                  </strong>{" "}
                                  {formatearFecha(c.fechaInstalacionCilindro)}
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                    </Row>

                    {registroSeleccionado.cilindros?.length === 0 && (
                      <div className="text-center text-muted py-3">
                        No hay cilindros registrados
                      </div>
                    )}
                  </CardBody>
                </Card>

                {/* ================= REGULADORES ================= */}
                <Card className="shadow-sm">
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">⚙️ Reguladores</h5>
                      <Badge color="secondary" pill>
                        {registroSeleccionado.reguladores?.length || 0}
                      </Badge>
                    </div>

                    <Row>
                      {(registroSeleccionado.reguladores || []).map((r, i) => (
                        <Col md="6" key={i} className="mb-3">
                          <Card className="border-0 shadow-sm h-100">
                            <CardBody className="d-flex justify-content-between align-items-center">
                              <div>
                                <div className="fw-bold text-primary">
                                  MARCA: {r.marcaRegulador || "Sin marca"}
                                </div>
                                <div className="small text-muted">
                                  Serial: {r.serialRegulador || "-"}
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                    </Row>

                    {registroSeleccionado.reguladores?.length === 0 && (
                      <div className="text-center text-muted py-3">
                        No hay reguladores registrados
                      </div>
                    )}
                  </CardBody>
                </Card>
              </>
            )}
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default ConsultaHistoricoSicom;
